/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Performancetable_Collections_Topdemos2Inputs */

const id_components_performancetable_collections_topdemos2 = /** @type {(inputs: Components_Performancetable_Collections_Topdemos2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demo Teratas`)
};

const ms_components_performancetable_collections_topdemos2 = /** @type {(inputs: Components_Performancetable_Collections_Topdemos2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demo Teratas`)
};

const da_components_performancetable_collections_topdemos2 = /** @type {(inputs: Components_Performancetable_Collections_Topdemos2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top demoer`)
};

const de_components_performancetable_collections_topdemos2 = /** @type {(inputs: Components_Performancetable_Collections_Topdemos2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top Demos`)
};

const en_us2_components_performancetable_collections_topdemos2 = /** @type {(inputs: Components_Performancetable_Collections_Topdemos2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top Demos`)
};

const es_es2_components_performancetable_collections_topdemos2 = /** @type {(inputs: Components_Performancetable_Collections_Topdemos2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demos destacadas`)
};

const es_mx2_components_performancetable_collections_topdemos2 = /** @type {(inputs: Components_Performancetable_Collections_Topdemos2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mejores demos`)
};

const fil_components_performancetable_collections_topdemos2 = /** @type {(inputs: Components_Performancetable_Collections_Topdemos2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Nangungunang Demo`)
};

const fr_components_performancetable_collections_topdemos2 = /** @type {(inputs: Components_Performancetable_Collections_Topdemos2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meilleures démos`)
};

const it_components_performancetable_collections_topdemos2 = /** @type {(inputs: Components_Performancetable_Collections_Topdemos2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Migliori demo`)
};

const hu_components_performancetable_collections_topdemos2 = /** @type {(inputs: Components_Performancetable_Collections_Topdemos2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legjobb demók`)
};

const nl_components_performancetable_collections_topdemos2 = /** @type {(inputs: Components_Performancetable_Collections_Topdemos2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top demo's`)
};

const no_components_performancetable_collections_topdemos2 = /** @type {(inputs: Components_Performancetable_Collections_Topdemos2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Topp demoer`)
};

const pl_components_performancetable_collections_topdemos2 = /** @type {(inputs: Components_Performancetable_Collections_Topdemos2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Najlepsze dema`)
};

const pt_br2_components_performancetable_collections_topdemos2 = /** @type {(inputs: Components_Performancetable_Collections_Topdemos2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Principais demos`)
};

const pt_components_performancetable_collections_topdemos2 = /** @type {(inputs: Components_Performancetable_Collections_Topdemos2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melhores demonstrações`)
};

const ro_components_performancetable_collections_topdemos2 = /** @type {(inputs: Components_Performancetable_Collections_Topdemos2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top Demo-uri`)
};

const fi_components_performancetable_collections_topdemos2 = /** @type {(inputs: Components_Performancetable_Collections_Topdemos2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parhaat demot`)
};

const sv_components_performancetable_collections_topdemos2 = /** @type {(inputs: Components_Performancetable_Collections_Topdemos2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Topp demos`)
};

const vi_components_performancetable_collections_topdemos2 = /** @type {(inputs: Components_Performancetable_Collections_Topdemos2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bản dùng thử hàng đầu`)
};

const tr_components_performancetable_collections_topdemos2 = /** @type {(inputs: Components_Performancetable_Collections_Topdemos2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En İyi Demolar`)
};

const cs_components_performancetable_collections_topdemos2 = /** @type {(inputs: Components_Performancetable_Collections_Topdemos2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nejlepší dema`)
};

const bg_components_performancetable_collections_topdemos2 = /** @type {(inputs: Components_Performancetable_Collections_Topdemos2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Топ демота`)
};

const ru_components_performancetable_collections_topdemos2 = /** @type {(inputs: Components_Performancetable_Collections_Topdemos2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Лучшие демо`)
};

const uk_components_performancetable_collections_topdemos2 = /** @type {(inputs: Components_Performancetable_Collections_Topdemos2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Найкращі демо`)
};

const ar_components_performancetable_collections_topdemos2 = /** @type {(inputs: Components_Performancetable_Collections_Topdemos2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أفضل العروض التجريبية`)
};

const hi_components_performancetable_collections_topdemos2 = /** @type {(inputs: Components_Performancetable_Collections_Topdemos2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टॉप डेमो`)
};

const th_components_performancetable_collections_topdemos2 = /** @type {(inputs: Components_Performancetable_Collections_Topdemos2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เดโม่ยอดนิยม`)
};

const ja_components_performancetable_collections_topdemos2 = /** @type {(inputs: Components_Performancetable_Collections_Topdemos2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トップデモ`)
};

const zh_cn2_components_performancetable_collections_topdemos2 = /** @type {(inputs: Components_Performancetable_Collections_Topdemos2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`热门试玩`)
};

const zh_hant1_components_performancetable_collections_topdemos2 = /** @type {(inputs: Components_Performancetable_Collections_Topdemos2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`熱門試玩版`)
};

const ko_components_performancetable_collections_topdemos2 = /** @type {(inputs: Components_Performancetable_Collections_Topdemos2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`데모 상위`)
};

/**
* | output |
* | --- |
* | "Top Demos" |
*
* @param {Components_Performancetable_Collections_Topdemos2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_performancetable_collections_topdemos2 = /** @type {((inputs?: Components_Performancetable_Collections_Topdemos2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Performancetable_Collections_Topdemos2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_performancetable_collections_topdemos2(inputs)
	if (locale === "ms") return ms_components_performancetable_collections_topdemos2(inputs)
	if (locale === "da") return da_components_performancetable_collections_topdemos2(inputs)
	if (locale === "de") return de_components_performancetable_collections_topdemos2(inputs)
	if (locale === "en-US") return en_us2_components_performancetable_collections_topdemos2(inputs)
	if (locale === "es-ES") return es_es2_components_performancetable_collections_topdemos2(inputs)
	if (locale === "es-MX") return es_mx2_components_performancetable_collections_topdemos2(inputs)
	if (locale === "fil") return fil_components_performancetable_collections_topdemos2(inputs)
	if (locale === "fr") return fr_components_performancetable_collections_topdemos2(inputs)
	if (locale === "it") return it_components_performancetable_collections_topdemos2(inputs)
	if (locale === "hu") return hu_components_performancetable_collections_topdemos2(inputs)
	if (locale === "nl") return nl_components_performancetable_collections_topdemos2(inputs)
	if (locale === "no") return no_components_performancetable_collections_topdemos2(inputs)
	if (locale === "pl") return pl_components_performancetable_collections_topdemos2(inputs)
	if (locale === "pt-BR") return pt_br2_components_performancetable_collections_topdemos2(inputs)
	if (locale === "pt") return pt_components_performancetable_collections_topdemos2(inputs)
	if (locale === "ro") return ro_components_performancetable_collections_topdemos2(inputs)
	if (locale === "fi") return fi_components_performancetable_collections_topdemos2(inputs)
	if (locale === "sv") return sv_components_performancetable_collections_topdemos2(inputs)
	if (locale === "vi") return vi_components_performancetable_collections_topdemos2(inputs)
	if (locale === "tr") return tr_components_performancetable_collections_topdemos2(inputs)
	if (locale === "cs") return cs_components_performancetable_collections_topdemos2(inputs)
	if (locale === "bg") return bg_components_performancetable_collections_topdemos2(inputs)
	if (locale === "ru") return ru_components_performancetable_collections_topdemos2(inputs)
	if (locale === "uk") return uk_components_performancetable_collections_topdemos2(inputs)
	if (locale === "ar") return ar_components_performancetable_collections_topdemos2(inputs)
	if (locale === "hi") return hi_components_performancetable_collections_topdemos2(inputs)
	if (locale === "th") return th_components_performancetable_collections_topdemos2(inputs)
	if (locale === "ja") return ja_components_performancetable_collections_topdemos2(inputs)
	if (locale === "zh-CN") return zh_cn2_components_performancetable_collections_topdemos2(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_performancetable_collections_topdemos2(inputs)
	return ko_components_performancetable_collections_topdemos2(inputs)
});
export { components_performancetable_collections_topdemos2 as "components.performanceTable.collections.topDemos" }